import React from "react";
import { CV } from "../components/cv";
import AlexanderRImg from "@/assets/images/alexander-r.png";

export default function CVAlexanderRaunert() {
  React.useEffect(() => {
    document.title = "BoldBrave CV - Alexander Raunert";
  }, []);

  return (
    <CV
      name="Alexander Raunert"
      photo={AlexanderRImg}
      title="Frontend Developer"
      subtitle="TypeScript and React for modern web applications and reusable UI components, with mobile development in Flutter and a backend background in Java."
      summary="Engaged frontend developer with experience in TypeScript, React, modern web applications and reusable UI components. Thrives where design meets code — user experience, accessibility, performance and technical quality. Has worked on complex SaaS products, component-based UI development, mobile development in Flutter and integrations against APIs, headless CMS solutions and backend flows. With a background in both frontend and backend, has a good understanding of how the different parts of a product fit together. Based in Malmö."
      skills={{
        "Key Skills": [
          "TypeScript",
          "React",
          "JavaScript",
          "HTML",
          "CSS",
          "REST API",
          "Git",
          "UI/UX",
          "WCAG",
        ],
        "Frontend & Design": [
          "Vite",
          "Next.js",
          "Web Components / Lit",
          "Storybook",
          "Design systems",
          "React Native",
          "Flutter",
        ],
        "Backend & CMS": [
          "Node.js",
          "Payload CMS",
          "Java",
          "Spring Boot",
          "SQL",
          "PostgreSQL",
          "MariaDB",
        ],
        "Tools & Environment": [
          "npm",
          "Docker",
          "CI/CD",
          "Cloud services",
          "AI-assisted development",
        ],
        Languages: ["Swedish", "English"],
      }}
      experience={[
        {
          role: "Frontend Developer",
          company: "TwoFour, Malmö",
          period: "2025 – 2026",
          description:
            "Development of a mobile application in Flutter with focus on clear user flows, stable navigation, animations and a responsive interface.",
          highlights: [
            "Implemented state management with Riverpod and deep linking for navigation straight to specific content in the app.",
            "Integrated authentication flows, APIs and a microservice-based backend, and structured content in Payload CMS with TypeScript.",
          ],
        },
        {
          role: "Frontend Developer",
          company: "Bionamic, Lund",
          period: "2022 – 2023",
          description:
            "Frontend development of a complex SaaS-based web application within life science, focused on TypeScript, component-based UI development, performance and maintainable interfaces.",
          highlights: [
            "Main responsibility for development, maintenance and publishing of an internal component library / design system based on Web Components and Lit, with focus on reusable UI components, consistent design and long-term stewardship.",
            "Close collaboration with UX designers to turn wireframes, design sketches and complex user requirements into intuitive, high-quality interfaces.",
            "Implemented robust and reusable UI components with focus on CSS, interface detail, user flows and a consistent user experience.",
          ],
        },
        {
          role: "Systems Developer",
          company: "Human IT, Malmö",
          period: "2020 – 2021",
          description:
            "Backend and integration development in Java for business-critical services.",
          highlights: [
            "Implemented BankID integrations against external APIs with Java and Retrofit 2.",
            "Extended business logic for complex price calculations, geographic data and copyright payouts.",
            "Refactoring, debugging and testing of Docker-based codebases with focus on stability and maintainability.",
          ],
        },
      ]}
      education={[
        {
          degree: "Frontend Development Web/Mobile (Vocational university)",
          institution: "Chas Academy, Malmö",
          year: "2024 – 2026",
        },
        {
          degree: "Systems Developer Java (Vocational university)",
          institution: "Newton Kompetensutveckling, Malmö",
          year: "2019 – 2021",
        },
      ]}
    />
  );
}
